import {
  IServerSideDatasource,
  IServerSideGetRowsParams,
} from "ag-grid-community";
import {
  FilterCriteria,
  GridDataRequest,
  GridDataResponse,
  SortCriteria,
} from "patients-experience-client";

export type DataProvider = (
  request: GridDataRequest
) => Promise<GridDataResponse>;

export class GridDataAdaptor implements IServerSideDatasource {
  private dataProvider?: DataProvider;

  private filters?: FilterCriteria[];

  constructor(private setShowNoRowsOverlay: (show: boolean) => void) {

  }

  getRows(params: IServerSideGetRowsParams): void {
    this.setShowNoRowsOverlay(false);

    const sortCriterias =
      params?.request.sortModel?.map((sort) => {
        return {
          propertyName: sort.colId,
          descending: sort.sort === "desc",
        } as SortCriteria;
      }) ?? [];

    const request: GridDataRequest = {
      filters: this.filters ?? [],
      sortCriteria: sortCriterias,
      startRow: params?.request?.startRow ?? 0,
      endRow: params?.request?.endRow ?? (params?.request?.startRow ?? 0) + 10,
    };

    this.dataProvider?.(request)
      .then((response) => {
        params.success({
          rowData: response.data,
          rowCount: response.total,
        });

        if (response.total == 0) {
          this.setShowNoRowsOverlay(true);
        }
      })
      .catch((error) => {
        console.error(error);
        params.fail();
      });
  }
  destroy?(): void {}

  public setDataProvider(provider: DataProvider) {
    this.dataProvider = provider;
  }

  public setFilters(filters: FilterCriteria[]) {
    this.filters = filters;
  }
}
